module.exports = ->
  window.getSelection?()?.toString() ||
  document.selection?.createRange().text
